import { ActionCreator } from 'redux';
import { Dispatch, ThunkAction } from '../../../../../../types/actions';
import { IGetState, TBoardId } from '../../../../../../types/types';
import { groupsExpand } from '../../../effects/groupsExpand';
import { groupsCollapse } from '../../../effects/groupsCollapse';
import { collapseGroupsSegmentEvent } from '../../../effects/segmentEvents';
import { getCollapsed } from '../../../selectors/getCollapsed';
import { collapsedSet } from '../../../store/listViewBoard/actions/collapsedSet';
import { listViewActionSet } from '../../../store/listView/actions/listViewActionSet';

export const onClickGroupsCollapseToggler: ActionCreator<ThunkAction> = (
     boardId: TBoardId,
) => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        const isCollapse = !getCollapsed(getState(), boardId);
        dispatch(listViewActionSet(boardId, collapsedSet(isCollapse)));
        if (isCollapse) {
            dispatch(groupsCollapse(boardId));
        } else {
            dispatch(groupsExpand(boardId));
        }
        dispatch(collapseGroupsSegmentEvent(!isCollapse));
    };
    return action;
};
